import { render } from "./ListIgnored.vue?vue&type=template&id=0f560aeb&ts=true"
import script from "./ListIgnored.vue?vue&type=script&lang=ts"
export * from "./ListIgnored.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Special/ListIgnored.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f560aeb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f560aeb', __exports__)) {
    api.reload('0f560aeb', __exports__)
  }
  
  module.hot.accept("./ListIgnored.vue?vue&type=template&id=0f560aeb&ts=true", () => {
    api.rerender('0f560aeb', render)
  })

}


export default __exports__